(() => {
  const money = (cents, format) => {
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents, format);
    return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'EUR'
    }).format(cents / 100);
  };

  const init = (root) => {
    if (root.dataset.burnReady === 'true') return;
    root.dataset.burnReady = 'true';

    const product = JSON.parse(root.querySelector('[data-burn-product-json]').textContent);
    const messages = JSON.parse(root.querySelector('[data-burn-translations]').textContent);
    const form = root.querySelector('[data-burn-product-form]');
    const variantInput = root.querySelector('[data-burn-variant-id]');
    const submit = root.querySelector('[data-burn-submit]');
    const submitLabel = root.querySelector('[data-burn-submit-label]');
    const price = root.querySelector('[data-burn-price]');
    const compare = root.querySelector('[data-burn-compare]');
    const status = root.querySelector('[data-burn-status]');
    const sticky = root.querySelector('[data-burn-sticky]');
    const stickyPrice = root.querySelector('[data-burn-sticky-price]');
    const stickyCompare = root.querySelector('[data-burn-sticky-compare]');
    const stickyVariant = root.querySelector('[data-burn-sticky-variant]');
    const stickySubmit = root.querySelector('[data-burn-sticky-submit]');
    const format = window.themeVariables?.settings?.moneyFormat;

    const finder = root.querySelector('[data-burn-finder-form]');
    finder?.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!finder.reportValidity()) return;
      const choice = Object.fromEntries(new FormData(finder));
      let suggestion;
      if (choice.platform === 'switch') {
        suggestion = ['Manette Nintendo Switch Pro personnalisée', '/products/manette-nintendo-switch-pro', 'Une option Nintendo à personnaliser selon vos goûts.'];
      } else if (choice.platform === 'ps5') {
        if (choice.priority === 'budget') suggestion = ['Manette PS5 à palettes Evo', '/products/manette-ps5-a-palettes-evo', 'Une première approche des palettes avec un budget maîtrisé.'];
        else if (choice.priority === 'design') suggestion = ['Manette PS5 à personnaliser', '/products/manette-ps5-personnaliser', 'Pour composer votre design et choisir vos options.'];
        else if (choice.games === 'fps') suggestion = ['Manette PS5 à palettes Pro FPS', '/products/manette-ps5-a-palettes-pro-fps', 'Des palettes, du remapping et des gâchettes mécaniques pour les jeux de tir.'];
        else suggestion = ['Manette PS5 à palettes Pro', '/products/manette-ps5-a-palettes-pro', 'Des palettes reconfigurables adaptées à différents types de jeux.'];
      } else if (choice.platform === 'xbox') {
        if (choice.priority === 'design') suggestion = ['Manette Xbox X/S personnalisée', '/products/manette-xbox-x-s-personnalisee', 'Pour privilégier le style et explorer les designs Xbox.'];
        else if (choice.priority === 'competition' && choice.games === 'fps') suggestion = ['Manette Xbox X/S à palettes Pro FPS', '/products/manette-xbox-x-s-palettes-pro-fps', 'Une piste orientée jeux de tir avec gâchettes mécaniques.'];
        else suggestion = ['Manette Xbox X/S à palettes Pro', '/products/manette-xbox-a-palettes-pro', choice.priority === 'budget' ? 'Une entrée accessible dans la gamme Xbox à palettes.' : 'Des palettes reconfigurables pour varier les jeux.'];
      }
      if (!suggestion) return;
      const result = finder.querySelector('[data-burn-finder-result]');
      result.querySelector('[data-burn-finder-name]').textContent = suggestion[0];
      result.querySelector('[data-burn-finder-reason]').textContent = suggestion[2];
      result.querySelector('[data-burn-finder-link]').href = suggestion[1];
      result.hidden = false;
    });
    finder?.querySelectorAll('select').forEach((select) => select.addEventListener('change', () => {
      finder.querySelector('[data-burn-finder-result]').hidden = true;
    }));

    const showMedia = (id) => {
      if (!id) return;
      const panels = [...root.querySelectorAll('[data-burn-media]')];
      const selected = panels.find((item) => item.dataset.burnMedia === String(id));
      if (!selected) return;
      const focusInThumbs = root.querySelector('[data-burn-thumb]:focus');
      panels.forEach((item) => {
        const active = item === selected;
        item.classList.toggle('is-active', active);
        item.hidden = !active;
        if (!active) item.querySelectorAll('video').forEach((video) => video.pause());
      });
      root.querySelectorAll('[data-burn-thumb]').forEach((item) => {
        const active = item.dataset.burnThumb === String(id);
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
        item.hidden = active;
      });
      if (focusInThumbs) selected.focus({ preventScroll: true });
    };

    const selectedOptions = () => [...root.querySelectorAll('[data-burn-option]')].map((group) => group.querySelector('input:checked')?.value);

    const setVariant = () => {
      const options = selectedOptions();
      const variant = product.variants.find((item) => item.options.every((value, index) => value === options[index]));
      if (!variant) {
        submit.disabled = true;
        submitLabel.textContent = messages.unavailableCombination;
        status.textContent = messages.unavailableNote;
        status.classList.add('is-error');
        return;
      }

      variantInput.value = variant.id;
      const formattedPrice = money(variant.price, format);
      price.textContent = formattedPrice;
      stickyPrice.textContent = formattedPrice;
      stickyVariant.textContent = variant.title === 'Default Title' ? stickyVariant.dataset.defaultLabel : variant.title;
      submit.disabled = !variant.available;
      stickySubmit.disabled = !variant.available;
      submitLabel.textContent = variant.available ? `${submit.dataset.burnAddLabel} - ${formattedPrice}` : messages.soldOut;
      status.textContent = '';
      status.classList.remove('is-error');

      const onSale = variant.compare_at_price > variant.price;
      price.classList.toggle('is-sale', onSale);
      stickyPrice.classList.toggle('is-sale', onSale);
      compare.hidden = !onSale;
      stickyCompare.hidden = !onSale;
      compare.textContent = onSale ? money(variant.compare_at_price, format) : '';
      stickyCompare.textContent = compare.textContent;

      if (variant.featured_media?.id) showMedia(variant.featured_media.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    root.querySelectorAll('[data-burn-option] input').forEach((input) => {
      input.addEventListener('change', () => {
        const group = input.closest('[data-burn-option]');
        group.querySelectorAll('.burn-pdp__choice').forEach((choice) => choice.classList.toggle('is-selected', choice.contains(input)));
        group.querySelector('[data-burn-option-current]').textContent = input.value;
        setVariant();
      });
    });

    root.querySelectorAll('[data-burn-thumb]').forEach((button) => button.addEventListener('click', () => showMedia(button.dataset.burnThumb)));

    const lightbox = root.querySelector('[data-burn-lightbox]');
    const lightboxImage = root.querySelector('[data-burn-lightbox-image]');
    root.querySelectorAll('button[data-burn-media]').forEach((button) => {
      button.addEventListener('click', () => {
        const image = button.querySelector('img');
        lightboxImage.src = image.currentSrc || image.src;
        lightboxImage.alt = image.alt;
        lightbox.showModal();
      });
    });
    root.querySelector('[data-burn-lightbox-close]')?.addEventListener('click', () => lightbox.close());
    lightbox?.addEventListener('click', (event) => { if (event.target === lightbox) lightbox.close(); });

    const addLines = async (lines) => {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: lines })
      });
      if (!response.ok) throw new Error((await response.json()).description || messages.addFailure);
      const added = await response.json();
      const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = cartResponse.ok ? await cartResponse.json() : null;
      if (cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'variant:add', cart }
        }));
      }
      form.dispatchEvent(new CustomEvent('variant:add', {
        bubbles: true,
        detail: { items: added.items || added }
      }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      return added;
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submit.disabled) return;
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      submitLabel.textContent = messages.adding;
      status.textContent = '';
      try {
        const lines = [{ id: Number(variantInput.value), quantity: 1 }];
        const accessory = root.querySelector('[data-burn-accessory]:checked');
        if (accessory) lines.push({ id: Number(accessory.value), quantity: 1 });
        await addLines(lines);
        status.textContent = messages.addedToCart;
        submitLabel.textContent = messages.added;
        window.setTimeout(setVariant, 1200);
      } catch (error) {
        setVariant();
        status.textContent = error.message;
        status.classList.add('is-error');
      } finally {
        submit.removeAttribute('aria-busy');
      }
    });

    root.querySelectorAll('[data-burn-card-add]').forEach((button) => {
      button.addEventListener('click', async () => {
        button.disabled = true;
        const previous = button.textContent;
        button.textContent = messages.addingShort;
        try {
          await addLines([{ id: Number(button.dataset.burnCardAdd), quantity: 1 }]);
          button.textContent = messages.added;
        } catch (error) {
          button.textContent = messages.error;
        }
        window.setTimeout(() => { button.disabled = false; button.textContent = previous; }, 1200);
      });
    });

    stickySubmit?.addEventListener('click', () => form.requestSubmit());
    if (sticky && submit && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => { sticky.hidden = entry.isIntersecting; }, { threshold: 0 });
      observer.observe(submit);
    }
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-burn-pdp]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
